// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"b1d2c3f7","459":"afcd07da","866":"4dd57687","936":"332676fa","964":"0b036c72"}[chunkId] + ".chunk.css";
};